<template>
  <a-drawer width="80%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="视频" prop="videoUrl">
        <a-upload listType="picture-card" accept=".mp4" class="avatar-uploader" v-model="form.videoUrl"
          :showUploadList="false" :customRequest="handleVideo">
          <div v-if="form.videoUrl">
            <video :src="videoUrl" width="300" height="150" controls></video>
          </div>
          <div v-else>
            <a-icon :type="uploadLoadingVideo ? 'loading' : 'plus'" />
            <div class="ant-upload-text">上传</div>
          </div>
        </a-upload>
        <a-progress style="margin-top: 10px;margin-bottom: 10px;width: 20%" v-if="this.uploadSize != 0"
          :percent=this.uploadSize />
      </a-form-model-item>

      <a-form-model-item label="模板图片" prop="imageUrl">
        <a-upload listType="picture-card" class="avatar-uploader" :fileList="[]" :showUploadList="false"
          :customRequest="handleChange">
          <img v-if="form.imageUrl" :src="form.imageUrl" alt="logo" style="height:104px;max-width:300px" />
          <div v-else>
            <a-icon :type="uploadLoading ? 'loading' : 'plus'" />
            <div class="ant-upload-text">上传(请优先上传 750px X 1000px 图片)</div>
          </div>
        </a-upload>
      </a-form-model-item><a-form-model-item label="封面图片" prop="coverImg">
        <a-upload listType="picture-card" class="avatar-uploader" :fileList="[]" :showUploadList="false"
          :customRequest="handleCoverChange">
          <img v-if="form.coverImg" :src="form.coverImg" alt="cover" style="height:104px;max-width:300px" />
          <div v-else>
            <a-icon :type="coverLoading ? 'loading' : 'plus'" />
            <div class="ant-upload-text">上传封面图</div>
          </div>
        </a-upload>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { addFaceSwap } from "@/api/video/video";
import UploadFileToVOD from "@/api/vod1.js"

export default {
  name: 'CreateForm',
  props: {},
  components: {},
  data() {
    return {
      bindVideoList: [],
      submitLoading: false,
      uploadLoading: false,
      uploadLoadingVideo: false,
      coverLoading: false,

      process: false,
      formTitle: '',

      uploadSize: 0,

      fileList: [],
      type: 0,
      listAll: [],
      isJup: false,
      // 表单参数
      form: {
        videoId: null,
        videoUrl: null,
        imageUrl: null,
        coverImg: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        videoUrl: [
          { required: true, message: '请上传视频', trigger: 'change' }
        ],
        imageUrl: [
          { required: true, message: '请上传图片', trigger: 'change' }
        ],
        coverImg: [
          { required: true, message: '请上传封面图片', trigger: 'change' }
        ]
      }
    }
  },
  filters: {},
  created() {
    this.uploadSize = 0
  },
  computed: {},
  watch: {},
  mounted() {
  },

  methods: {
    handleVideo(info) {
      if (info.file.status === 'uploading') {
        this.uploadLoadingVideo = true;
        return;
      }

      this.form.videoUrl = "";
      const self = this; // 保存 Vue 实例
      new UploadFileToVOD([info.file], {
        success(fileName) {
          self.form.videoUrl = fileName[0];
          self.uploadLoadingVideo = false;
        },
        vProgress(val) {
          self.uploadSize = val * 100;
        }
      });
    },

    handleChange(info) {
      this.uploadLoading = true;
      new UploadFileToVOD([info.file], {
        success: (fileName) => {
          console.log("上传成功:", fileName);
          this.form.imageUrl = fileName[0];
          this.uploadLoading = false;
        }
      });
    },

    beforeUpload: function (file) {
      var fileType = file.type;
      if (fileType.indexOf('image') < 0) {
        this.$message.warning('请上传图片');
        this.uploadLoading = false
        return false;
      }
      //TODO 驗證文件大小
    },

    handleCoverChange(info) {
      this.coverLoading = true;
      new UploadFileToVOD([info.file], {
        success: (fileName) => {
          console.log("上传成功:", fileName);
          this.form.coverImg = fileName[0];
          this.coverLoading = false;
        }
      });
    },
    onClose() {
      this.isJup = false
      this.uploadSize = 0
      this.open = false
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.formType = 1;
      this.uploadSize = 0;
      this.form = {
        id: null,
        videoUrl: null,
        imageUrl: null,
        coverImg: null,
        videoId: null
      };
    },

    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset();
      this.form.videoId = row; // ✅ 提交时 form 里有 id
      this.open = true;
      this.formTitle = '添加';
    },

    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true

          addFaceSwap(this.form).then(response => {
            this.$message.success(
              '新增成功',
              3
            )
            this.open = false
            this.$emit('ok')
          }).finally(() => {
            this.submitLoading = false
          })
        }
      })
    }
  }
}
</script>